import { Map } from 'immutable';

import { getSize } from '../../../iterable/getSize';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function files({ channel, operation, preview }) {
  const payload = [];

  for (let index = 0; index < getSize(preview.getIn([ATTRIBUTE.FILES, VALUE])); index += 1) {
    switch (operation) {
      case OPERATIONS[channel].FILES.ADD: {
        payload.push(Map({ type: operation, value: preview.getIn([ATTRIBUTE.FILES, VALUE, index]) }));
        break;
      }

      case OPERATIONS[channel].FILES.REPLACE: {
        const value = preview.getIn([ATTRIBUTE.FILES, VALUE, index]);

        if (!value) continue;

        payload.push(Map({ type: operation, value: Map({ targetIndex: index, replacement: value }) }));
        break;
      }

      case OPERATIONS[channel].FILES.DELETE: {
        if (!preview.getIn([ATTRIBUTE.FILES, VALUE, index])) continue;

        payload.unshift(Map({ type: operation, value: Map({ targetIndex: index }) }));
        break;
      }

      default:
        break;
    }
  }

  return { payload };
}
